import { render, staticRenderFns } from "./WarningBubble.vue?vue&type=template&id=31c08982&"
import script from "./WarningBubble.vue?vue&type=script&lang=js&"
export * from "./WarningBubble.vue?vue&type=script&lang=js&"
import style0 from "./WarningBubble.vue?vue&type=style&index=0&id=31c08982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports